module.exports = __webpack_public_path__ + "static/media/exprewards.fafa260f.png";